import { useEffect, useState } from "react";
import { foldSearchText } from "../../core/commande/model/commandeListSearch";
import { ClassificationLabels } from "../../models/classification.map";

// Recherche libre des tableaux de production : le texte part au serveur (paramètre q),
// qui ne renvoie que les lignes dont l'EHPAD, le patient, le produit, la classification,
// le statut ou la date de réception correspondent.

export const PRODUCTION_SEARCH_DELAY_MS = 300;

export function useDebouncedValue(value, delay = PRODUCTION_SEARCH_DELAY_MS) {
    const [debounced, setDebounced] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => setDebounced(value), delay);
        return () => clearTimeout(timer);
    }, [value, delay]);
    return debounced;
}

const STATUT_SEARCH_LABELS = {
    TRAITE: "Traité",
    EN_COMMANDE: "En commande",
    EN_RUPTURE: "En rupture",
    NON_LIVRE: "Non livré",
};

function dateTexts(isoDateTime) {
    const [date] = String(isoDateTime ?? "").split("T");
    const [year, month, day] = date.split("-");
    if (!year || !month || !day) return [];
    return [`${day}/${month}/${year}`, `${day}-${month}-${year}`, date];
}

// Même règle que le serveur, pour les lignes chargées hors pagination (CNO).
export function matchesProductionSearch(row, query) {
    const term = foldSearchText(query).trim();
    if (!term) return true;
    const patient = [row.patientNom, row.patientPrenom].filter(Boolean);
    const values = [
        row.ehpadNom,
        row.ehpadCode,
        ...patient,
        patient.join(" "),
        [...patient].reverse().join(" "),
        row.nom,
        ClassificationLabels[row.classification] ?? row.classification,
        row.statut ? STATUT_SEARCH_LABELS[row.statut] : "Non traité",
        ...dateTexts(row.dateReception),
    ];
    return values.some(value => value && foldSearchText(value).includes(term));
}
